/*
 * Grossansicht (Lightbox) beschleunigen.
 *
 * Problem (Feedback 12.08.): Beim Durchklicken in der Grossansicht wurde
 * jedes Bild erst in dem Moment geladen, in dem es angezeigt werden soll.
 * Dadurch entstand pro Klick eine spuerbare Wartezeit von ein bis zwei
 * Sekunden.
 *
 * Loesung: Sobald jemand mit der Galerie interagiert (Maus darueber, Klick
 * oder Tippen), werden alle Bilder der Grossansicht im Hintergrund geladen.
 * Beim Durchklicken kommen sie dann direkt aus dem Cache. Bewusst erst bei
 * Interaktion, damit der normale Seitenaufbau keine unnoetigen Daten zieht.
 */
(function () {
  var start = function () {
    var node = document.getElementById('ProductImagesData');
    if (!node) return;

    var data = [];
    try {
      data = JSON.parse(node.textContent) || [];
    } catch (e) {
      return;
    }
    if (data.length < 2) return;

    var done = false;
    var preloadAll = function () {
      if (done) return;
      done = true;
      data.forEach(function (item, index) {
        if (!item || !item.src) return;
        window.setTimeout(function () {
          var img = new Image();
          img.decoding = 'async';
          img.src = item.src;
        }, index * 60);
      });
    };

    var bind = function (el) {
      if (!el) return;
      el.addEventListener('mouseenter', preloadAll, { once: true });
      el.addEventListener('focus', preloadAll, { once: true });
      el.addEventListener('click', preloadAll, { once: true });
      el.addEventListener('touchstart', preloadAll, { once: true, passive: true });
    };

    var triggers = document.querySelectorAll(
      '[data-lightbox-open], #ProductMainImage, .product__thumbnail, .product__arrow'
    );
    Array.prototype.forEach.call(triggers, bind);
    bind(document.getElementById('ProductStage'));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
